/* This is a raw multi-provider LLM Client
 * See llm.ts for a version that uses preferences to fetch using selected provider
 */

import { validateReply, processReply } from "./llm_client/reply_validation";
import { base_domain } from './backend'
import stt from '@/components/Chat/STT'

export const llmProviderEndpoints = {
    'Convolution': {
        url: `${base_domain}/llm_api`,
        tts: true
    },
    'Cerebras': {
        url: 'https://api.cerebras.ai/v1',
        tts: false
    },
    'Grok': {
        url: 'https://api.groq.com/openai/v1',
        tts: true
    },
    'Gemini': {
        url: 'https://generativelanguage.googleapis.com/v1beta/openai',
        tts: false
    }
}

window.providers = llmProviderEndpoints;

export function providerNeedsAPIKeyAndModel(provider: string) {
    return provider !== "Convolution"
}

export type LlmProvider = keyof typeof llmProviderEndpoints;

export async function getModels(llmProvider: LlmProvider, key: string | null) {
    console.log("getModels")
    if (!providerNeedsAPIKeyAndModel(llmProvider)) return;

    const base_url = llmProviderEndpoints[llmProvider].url

    const response = await fetch(base_url + '/models', {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${key}`,
                "Content-Type": "application/json"
            }
        }
    )
    if (response === undefined || response.status === 403 || response.status === 401) {
        console.log("Not authenticated")
        return;
    }

    const data = await response.json()
    return data.data
        .map(x => x.id)
        //.filter(x => !/whisper|tts|guard/i.test(x))
}

import { Message } from './backend'
import backend from './backend'

export async function sleep(ms) {
    await new Promise(resolve => setTimeout(resolve, ms));
}

// For saving chats to server
export async function getResponse(llmProvider: LlmProvider, key: string | null, model: string, chat_id: string, messages: Message[]) {
    const base_url = llmProviderEndpoints[llmProvider].url

    while (true) {
        let response;
        try {
            response = await fetch(base_url + '/chat/completions',
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${key}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        model: model,
                        // For ollama:
                        //stream: true,
                        // options: {
                        //     num_predict: 128,
                        //     temperature: 1.0,
                        //     top_p: 0.95,
                        //     top_k: 64
                        // },
                        //chat_id,
                        // For OpenAI compatible:
                        max_tokens: 512,
                        // Grok doesn't support type field
                        messages: messages.map(m => {return {role: m.role, content: m.content}})
                    })
                }
            )
        } catch (e) {
            console.log("fetch error:", e);
            await sleep(1000);
            continue;
        }

        if (response === undefined || response.status === 403 || response.status === 401) {
            console.log("Not authenticated")
            return;
        }
        
        const r = await response.json()
        console.log(r)
        let reply = r.choices[0].message.content;
        reply = reply.replace(/.*<\/think>/s, "").trim();

        if (!validateReply(reply, messages[0].content)) {
            console.log("Reply validation failed", reply)
            console.log("Regenerating....")
            continue
        }

        reply = processReply(reply);

        return {reply, chat_id}
    }
}

// STT

export async function speechGetResponse(llmProvider: LlmProvider, key: string | null, model: string, chat_id: string, voice: File) {
    const base_url = llmProviderEndpoints[llmProvider].url

    const formData = new FormData();
    formData.append('model', 'whisper-large-v3');
    formData.append('url', voice);
    formData.append('language', stt.state.langcode);
    formData.append('prompt', 'Student response to a teacher.')
    formData.append('response_format', 'verbose_json');

    while (true) {
        let response;
        try {
            response = await fetch(base_url + '/audio/transcriptions',
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${key}`,
                    },
                    body: formData
                }
            )
        } catch (e) {
            console.log("fetch error:", e);
            await sleep(1000);
            continue;
        }

        if (response === undefined || response.status === 403 || response.status === 401) {
            console.log("Not authenticated")
            return;
        }
        
        const r = await response.json()
        console.log(r)

        const reply = r;//.text;

        return {reply, chat_id} //chat_id: await backend.save_chat(messages, reply, chat_id)}
    }
}

export default { getModels, getResponse, speechGetResponse }